export const buildSyntheticHeaderId = ({
  category,
  lot,
}: {
  category?: string
  lot?: string
}) => {
  const categoryKey = encodeURIComponent(category?.trim() || 'uncategorized')
  const lotKey = encodeURIComponent(lot?.trim() || 'no-lot')
  return `catalog-header:${lotKey}:${categoryKey}`
}
